
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: '홈', href: '/' },
    { name: '회사소개', href: '/about' },
    { name: '3PL FULFILLMENT', href: '/fulfillment' },
    { name: 'WMS', href: '/wms' },
    { name: '협력사', href: '/partners' },
    { name: '찾아오시는길', href: '/location' },
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/f7b0049a0cc45da5eac0364132373b3c.jpeg" 
              alt="올딩스 로지스" 
              className="h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              홈
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              회사소개
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              서비스소개
            </Link>
            <Link to="/fulfillment" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              풀필먼트
            </Link>
            <Link to="/wms" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              WMS
            </Link>
            <Link to="/partners" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              협력사
            </Link>
            <Link to="/consultation" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              상담예약
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              문의하기
            </Link>
            <Link to="/location" className="text-gray-700 hover:text-blue-600 transition-colors text-lg font-medium">
              오시는길
            </Link>
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="text-sm text-gray-600">
              <div className="flex items-center">
                <i className="ri-phone-line mr-1"></i>
                010-3099-5677
              </div>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                홈
              </Link>
              <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                회사소개
              </Link>
              <Link to="/services" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                서비스소개
              </Link>
              <Link to="/fulfillment" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                풀필먼트
              </Link>
              <Link to="/wms" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                WMS
              </Link>
              <Link to="/partners" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                협력사
              </Link>
              <Link to="/consultation" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                상담예약
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                문의하기
              </Link>
              <Link to="/location" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors text-base">
                오시는길
              </Link>
              <div className="px-3 py-2 text-sm text-gray-600 border-t mt-2 pt-4">
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  010-3099-5677
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
